"use client"

import { Divider } from "@heroui/divider"

export default function PageClient() {
  return (
    <div className="flex-col items-center px-3 pt-4 text-[#1D2129] sm:px-[120px] sm:pt-10">
      <div className="mb-3 text-[24px] font-bold sm:text-[36px]">
        How to Earn Money with SnapThePrice
      </div>
      <div className="mb-6 sm:mb-[40px]">
        Online shopping isn’t just about finding the best deals anymore—it’s
        also about earning while you shop. With SnapThePrice, you can enjoy
        both: smarter shopping and real cash rewards. If you’ve ever wished your
        everyday browsing could bring you extra income, here’s how to make the
        most out of SnapThePrice’s Rewards Program.
      </div>
      <div className="opacity-100">
        <Divider />
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mt-[32px] sm:mb-3">
        1. Get Your $5 Sign-Up Bonus
      </div>
      <div className="mb-3 text-[14px] sm:mb-8">
        The first step is simple: install SnapThePrice and sign up. As a welcome
        gift, every new user instantly earns $5 Rewards credited to their
        account. It’s our way of saying thanks for joining.
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        2. Earn $0.05 Every Time You Snap
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        SnapThePrice makes product comparison easy with just one click—what we
        call a Snap. Each time you Snap a product to find the lowest available
        price, you’ll earn $0.05 Rewards. The more you shop and compare, the
        more you earn.
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">Think of it this way:</div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">10 Snaps = $0.50</li>
        <li className="mb-2">100 Snaps = $5</li>
        <li className="mb-3 sm:mb-8">
          And there’s no limit—your earnings grow with your activity.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        3. Invite Friends, Get Bonus Rewards
      </div>
      <div className="mb-3 text-[14px] sm:mb-8">
        Why keep the perks to yourself? Share SnapThePrice with your friends and
        family. For every successful referral, you’ll earn bonus Rewards—and
        they’ll enjoy the same $5 sign-up bonus you did. It’s a win-win.
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        4. Redeem Your Rewards Easily
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        Once you’ve accumulated enough Rewards, cashing out is simple. You can
        redeem your earnings via:
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">PayPal – direct cash transfer.</li>
        <li className="mb-2">
          Amazon Gift Cards – perfect for your next purchase.
        </li>
      </ul>
      <div className="mb-3 text-[14px] sm:mb-8">
        We designed the process to be fast, flexible, and hassle-free, so you
        can enjoy the benefits of your smart shopping right away.
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        5. Shopping Smarter, Earning More
      </div>
      <div className="mb-3 text-[14px] sm:mb-8">
        What makes SnapThePrice unique is that it’s more than just a browser
        extension. With our AI Shopping Assistant powered by ChatGPT, you’ll get
        personalized recommendations, smarter product searches, and the
        confidence of always finding the lowest offer. And the best part? You’re
        rewarded every step of the way.
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">Final Thoughts</div>
      <div className="mb-2 text-[14px] sm:mb-6">
        Earning money with SnapThePrice is easy: Sign up, Snap, Share, and
        Redeem. Whether you’re a casual shopper or someone who loves finding
        deals, our Rewards Program ensures that your time online pays off.
      </div>
      <div className="mb-2 text-[14px] sm:mb-6">
        👉 Install SnapThePrice today and start turning your browsing into
        earnings.
      </div>
    </div>
  )
}
